import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import VenueView from "../../venues/views/VenueView";
import i18n from "../../../i18n";

import { route } from "../../../routes";
import {
  FormUtility,
  withAddressFinderApi,
  withVenuesApi,
} from "cw-styleguide-react";

import { LANGUAGE_CY, LANGUAGE_EN } from "../../../constants";
import withAuditApi from "../../../apis/withAuditApi";

class VenueController extends Component {
  /**
   * constructor.
   * @param props
   */
  constructor(props) {
    super(props);

    // State.
    this.state = {
      inputLanguage: LANGUAGE_EN,
      values: this.getInitialValues(),
      formErrors: {},
      modals: {
        bulkDelete: false,
        bulkArchive: false,
        bulkRollback: false,
        delete: false,
        archive: false,
        rollback: false,
      },
      reloadKey: Math.random(),
      loaded: false,
      messages: new Set(),
      redirect: null,
      selected: new Set(),
      showAddressSuggestions: false,
      query: ''
    };

    this.archiveVenue = this.archiveVenue.bind(this);
    this.rollbackVenue = this.rollbackVenue.bind(this);
    this.deleteVenue = this.deleteVenue.bind(this);
    this.loadAudit = this.loadAudit.bind(this);
    this.clearAudit = this.clearAudit.bind(this);
    this.loadVenue = this.loadVenue.bind(this);
    this.saveVenue = this.saveVenue.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleBulkCheckbox = this.handleBulkCheckbox.bind(this);
    this.clearMessages = this.clearMessages.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.hasManualAddress = this.hasManualAddress.bind(this);
    this.handleManualAddress = this.handleManualAddress.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.clearRedirect = this.clearRedirect.bind(this);
    this.clearVenue = this.clearVenue.bind(this);
    this.handleFindAddress = this.handleFindAddress.bind(this);
    this.handleSelectAddress = this.handleSelectAddress.bind(this);
    this.clearAddressSuggestions = this.clearAddressSuggestions.bind(this);
    this.setQuery = this.setQuery.bind(this);
    this.handleSetInputLanguage = this.handleSetInputLanguage.bind(this);
    this.handleErrorClick = this.handleErrorClick.bind(this);
    this.setReloadKey = this.setReloadKey.bind(this);
  }

  /**
   * getInitialValues
   */
  getInitialValues() {
    return {
      id: "",
      venueName_en: "",
      venueName_cy: "",
      townCity_en: "",
      townCity_cy: "",
      extraFacilities_en: "",
      extraFacilities_cy: "",
      learnerSupport: new Set(),
      facilitiesAvailable: new Set(),
      addressLine1_en: "",
      addressLine1_cy: "",
      addressLine2_en: "",
      addressLine2_cy: "",
      addressLine3_en: "",
      addressLine3_cy: "",
      addressLine4_en: "",
      addressLine4_cy: "",
      county_en: "",
      county_cy: "",
      postCode: "",
      translatorAssigned: "",
    };
  }

  /**
   * clearContact
   */
  clearVenue() {
    this.setState({
      inputLanguage: LANGUAGE_EN,
      manualAddress: false,
      values: this.getInitialValues(),
    });
  }

  /**
   * clearSelected
   */
  clearRedirect() {
    this.setState({
      redirect: null,
    });
  }

  /**
   * clearSelected
   */
  clearSelected() {
    this.setState({
      selected: new Set(),
    });
  }

  /**
   * clearMessages
   */
  clearMessages() {
    this.setState({
      messages: new Set(),
      formErrors: {},
    });
  }

  /**
   * Set a new reload key forcing a page refresh.
   */
  setReloadKey() {
    this.setState({
      reloadKey: Math.random(),
    });
  }

  /**
   * toggleModal
   * @param id
   */
  toggleModal(ids, visiblity) {
    const modals = { ...this.state.modals };

    // loop through the ids.
    ids.forEach((id) => {
      modals[id] = visiblity;
    });

    this.setState({
      modals: modals,
    });
  }

  /**
   * handleBulkCheckbox
   * @param event
   */
  handleBulkCheckbox(event) {
    const selected = this.state.selected;
    if (selected.has(event.target.value)) {
      selected.delete(event.target.value);
    } else {
      selected.add(event.target.value);
    }
    this.setState({
      selected: selected,
    });
  }

  /**
   * Handle field onChange events and save to the state.
   * @param event
   */
  handleChange(event) {
    const values = { ...this.state.values };

    this.setState({
      values: FormUtility.setFormValues(event, values),
    });
  }

  handleFindAddress(event) {
    event.preventDefault();
    this.props.addressFinderApiGetAddress(
      this.state.values.postCode,
      (response) => {
        this.setState({
          addresses: response.data.addresses,
          showAddressSuggestions: true,
        });
      },
      (error) => {}
    );
  }

  clearAddressSuggestions(event) {
    this.setState({
      showAddressSuggestions: false,
    });
  }

  /**
   * Handle address lookup selection.
   * @param event
   */
  handleSelectAddress(event) {
    event.preventDefault();
    const values = { ...this.state.values };

    values.addressLine1_en = event.target.dataset.addressline1 || "";
    values.addressLine2_en = event.target.dataset.addressline2 || "";
    values.addressLine3_en = event.target.dataset.addressline3 || "";
    values.addressLine4_en = event.target.dataset.addressline4 || "";
    values.county_en = event.target.dataset.county || "";
    values.townCity_en = event.target.dataset.towncity || "";
    values.postCode = event.target.dataset.postcode || "";

    // Update welsh
    values.addressLine1_cy = event.target.dataset.addressline1 || "";
    values.addressLine2_cy = event.target.dataset.addressline2 || "";
    values.addressLine3_cy = event.target.dataset.addressline3 || "";
    values.addressLine4_cy = event.target.dataset.addressline4 || "";
    values.county_cy = event.target.dataset.county || "";
    values.townCity_cy = event.target.dataset.towncity || "";

    this.setState({
      values: values,
      manualAddress: true,
      showAddressSuggestions: false,
    });
  }

  /**
   * archiveVenues
   * @param ids
   */
  archiveVenue(ids, redirect = null) {
    this.props.venuesApiArchiveVenue(
      ids,
      i18n.language,
      (response) => {
        let messages = new Set();

        // Display a plural or singular message on successful deletion.
        if (response.data.venueIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.venues.manage.messages.archive.singular",
              { count: response.data.venueIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.venues.manage.messages.archive.plural",
              { count: response.data.venueIds.length }
            ),
          });
        }

        this.setState({
          formErrors: [],
          messages: messages,
          selected: new Set(),
          reloadKey: Math.random(),
          redirect: redirect,
        });
        this.toggleModal(["archive", "bulkArchive"], false);
      },
      (error) => {
        this.toggleModal(["archive", "bulkArchive"], false);
        this.setState(FormUtility.processServerErrors(error, i18n));
      }
    );
  }

  /**
   * Rollback a set of courses.
   * @param ids
   */
  rollbackVenue(ids, redirect = null) {
    this.props.venuesApiDeleteDraft(
      ids,
      i18n.language,
      (response) => {
        let messages = new Set();

        // Display a plural or singular message on successful deletion.
        if (response.data.venueIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.venues.manage.messages.rollback.singular",
              { count: response.data.venueIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.venues.manage.messages.rollback.plural",
              { count: response.data.venueIds.length }
            ),
          });
        }

        this.setState({
          formErrors: [],
          messages: messages,
          selected: new Set(),
          reloadKey: Math.random(),
          redirect: redirect,
        });
        this.toggleModal(["rollback", "bulkRollback"], false);
      },
      (error) => {
        this.toggleModal(["rollback", "bulkRollback"], false);
        this.setState(FormUtility.processServerErrors(error, i18n));
      }
    );
  }

  /**
   * courseDelete
   * @param courses
   * @param callback
   */
  deleteVenue(ids, redirect = null) {
    this.props.venuesApiDeleteVenue(
      ids,
      i18n.language,
      (response) => {
        let messages = new Set();

        if (response.data.venueIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.venues.manage.messages.delete.singular",
              { count: response.data.venueIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t("local:view.venues.manage.messages.delete.plural", {
              count: response.data.venueIds.length,
            }),
          });
        }

        this.setState({
          formErrors: [],
          messages: messages,
          selected: new Set(),
          reloadKey: Math.random(),
          redirect: redirect,
        });
        this.toggleModal(["delete", "bulkDelete"], false);
      },
      (error) => {
        this.toggleModal(["delete", "bulkDelete"], false);
        this.setState(FormUtility.processServerErrors(error, i18n));
      }
    );
  }

  /**
   * loadAudit
   * @param id
   */
  loadAudit(id) {
    this.props.auditApiGetAudit(
      id,
      "venue",
      i18n.language,
      (response) => {
        this.setState({
          audit: response.data,
        });
      },
      (error) => {
        this.setState({
          audit: false,
        });
      }
    );
  }

  /**
   * Load a venue for a given ID.
   * @param id
   */
  loadVenue(id) {
    this.setState({
      loaded: false,
    });
    this.props.venuesApiGetVenue(
      id,
      i18n.language,
      (response) => {
        this.setState({
          values: {
            id: response.data[0].id,
            venueName_en: response.data[0].venueName.en,
            venueName_cy: response.data[0].venueName.cy,
            townCity_en: response.data[0].townCity.en,
            townCity_cy: response.data[0].townCity.cy,
            extraFacilities_en: response.data[0].extraFacilities.en,
            extraFacilities_cy: response.data[0].extraFacilities.cy,
            learnerSupport: new Set(response.data[0].learnerSupport),
            facilitiesAvailable: new Set(response.data[0].facilitiesAvailable),
            addressLine1_en: response.data[0].addressLine1.en,
            addressLine1_cy: response.data[0].addressLine1.cy,
            addressLine2_en: response.data[0].addressLine2.en,
            addressLine2_cy: response.data[0].addressLine2.cy,
            addressLine3_en: response.data[0].addressLine3.en,
            addressLine3_cy: response.data[0].addressLine3.cy,
            addressLine4_en: response.data[0].addressLine4.en,
            addressLine4_cy: response.data[0].addressLine4.cy,
            county_en: response.data[0].county.en,
            county_cy: response.data[0].county.cy,
            postCode: response.data[0].postCode,
            status: response.data[0].status,
            translatorAssigned: response.data[0].translatorAssigned,
          },
          loaded: true,
        });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          loaded: false,
        });
      }
    );
  }

  /**
   * setQuery
   * @param value
   */
  setQuery(value) {
    this.setState({
      query: value,
    });
  }

  clearAudit() {
    this.setState({
      audit: false,
    });
  }

  /**
   * saveVenue
   * @param status
   */
  saveVenue(status) {
    // Start the spinner going, will be removed on success or failure of the submit.
    this.setState({
      submitting: true,
    });

    // Build the Post JSON.
    let payload = {
      venueName: {
        cy: this.state.values.venueName_cy,
        en: this.state.values.venueName_en,
      },
      addressLine1: {
        cy: this.state.values.addressLine1_cy,
        en: this.state.values.addressLine1_en,
      },
      addressLine2: {
        cy: this.state.values.addressLine2_cy,
        en: this.state.values.addressLine2_en,
      },
      addressLine3: {
        cy: this.state.values.addressLine3_cy,
        en: this.state.values.addressLine3_en,
      },
      addressLine4: {
        cy: this.state.values.addressLine4_cy,
        en: this.state.values.addressLine4_en,
      },
      county: {
        cy: this.state.values.county_cy,
        en: this.state.values.county_en,
      },
      townCity: {
        cy: this.state.values.townCity_cy,
        en: this.state.values.townCity_en,
      },
      postCode: this.state.values.postCode,
      extraFacilities: {
        cy: this.state.values.extraFacilities_cy,
        en: this.state.values.extraFacilities_en,
      },
      facilitiesAvailable: Array.from(this.state.values.facilitiesAvailable),
      learnerSupport: Array.from(this.state.values.learnerSupport),
      status: status,
    };

    // If we have and ID then add it.
    if (this.state.values.id) {
      payload.id = this.state.values.id;
    }

    this.props.venuesApiPostVenue(
      payload,
      i18n.language,
      (response) => {
        // Save the current state of messages.
        let messages = this.state.messages;

        messages.add({
          type: "positive",
          message: i18n.t(
            "local:view.venues.status." + response.data.status + ".success"
          ),
        });
        this.setState({
          formErrors: [],
          redirect: route("venuesManage") + this.state.query,
        });

        // Set the messages.
        this.setState({ messages: messages });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  /**
   * hasManualAddress
   * @returns {*|string}
   */
  hasManualAddress() {
    const values = { ...this.state.values };
    return (
      this.state.manualAddress ||
      values.addressLine1_en ||
      values.addressLine2_en
    );
  }

  /**
   * Handle clicking on the enter manual address link.
   * @param event
   */
  handleManualAddress(event) {
    event.preventDefault();
    this.setState({
      manualAddress: true,
      showAddressSuggestions: false,
    });
  }

  /**
   * Keep track of the current input language.
   * @param event
   */
  handleSetInputLanguage(e) {
    e.preventDefault();
    this.setState({
      inputLanguage: e.target.value,
    });
  }

  /**
   * Perform a customised action if someone clicks on an error in the summary. Used to change the language to welsh.
   * @param event
   * @param field
   */
  handleErrorClick(e, field) {
    this.setState({
      inputLanguage: field.includes("_cy") ? LANGUAGE_CY : LANGUAGE_EN,
    });
  }

  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <VenueView
          {...this.state}
          archiveVenue={this.archiveVenue}
          rollbackVenue={this.rollbackVenue}
          deleteVenue={this.deleteVenue}
          loadAudit={this.loadAudit}
          clearAudit={this.clearAudit}
          loadVenue={this.loadVenue}
          saveVenue={this.saveVenue}
          toggleModal={this.toggleModal}
          handleBulkCheckbox={this.handleBulkCheckbox}
          clearMessages={this.clearMessages}
          clearSelected={this.clearSelected}
          handleManualAddress={this.handleManualAddress}
          hasManualAddress={this.hasManualAddress}
          handleChange={this.handleChange}
          clearRedirect={this.clearRedirect}
          clearVenue={this.clearVenue}
          handleFindAddress={this.handleFindAddress}
          handleSelectAddress={this.handleSelectAddress}
          clearAddressSuggestions={this.clearAddressSuggestions}
          handleSetInputLanguage={this.handleSetInputLanguage}
          handleErrorClick={this.handleErrorClick}
          setReloadKey={this.setReloadKey}
          setQuery={this.setQuery}
        />
      </Fragment>
    );
  }
}

export default withAuditApi(process.env)(
  withAddressFinderApi(process.env)(
    withVenuesApi(process.env)(withTranslation("local")(VenueController))
  )
);
